import { render, staticRenderFns } from "./wamserver.vue?vue&type=template&id=502ff969"
import script from "./wamserver.vue?vue&type=script&lang=js"
export * from "./wamserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports